import { render, staticRenderFns } from "./xwgl.vue?vue&type=template&id=34c5da66&scoped=true&"
import script from "./xwgl.vue?vue&type=script&lang=js&"
export * from "./xwgl.vue?vue&type=script&lang=js&"
import style0 from "./xwgl.vue?vue&type=style&index=0&id=34c5da66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5da66",
  null
  
)

export default component.exports